var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.98 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.95,6.51,20.8,1.38a.4.4,0,0,0-.37-.25.4.4,0,0,0-.15,0l-3.11,1.3,2.53,2a1.67,1.67,0,0,1,.63,1.12,1.69,1.69,0,0,1-.17,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.28,4.21a1.7,1.7,0,0,1,.9.93,1.67,1.67,0,0,1,0,1.28l0,.09h4.45L19,6a.4.4,0,0,0-.07-.56L12,.09a.4.4,0,0,0-.56.07L9.56,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.78,5.39,4.78,2a.4.4,0,0,0-.16,0,.4.4,0,0,0-.37.24L2.4,6.51H12.74l.26-.6a.4.4,0,0,0-.21-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.69,8.62a1.17,1.17,0,0,0-.88-.4H1.17A1.17,1.17,0,0,0,0,9.55L1.38,19a1.17,1.17,0,0,0,1.16,1H22.44a1.17,1.17,0,0,0,1.16-1L25,9.55A1.17,1.17,0,0,0,24.69,8.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiContent);
export default __webpack_public_path__ + "static/media/noti-content.860fc7dc9ddd45c7493801ab41d0f4c7.svg";
export { ForwardRef as ReactComponent };